import React from "react";
import { cn } from "@lemonadetraining/web-ui";
import appStoreBadge from "../../assets/stores/app-store-badge.svg";
import googlePlayBadge from "../../assets/stores/google-play-badge.png";

// Official badge artwork, hosted by us: hot-linked badges break under the site's CSP.
const STORES = [
  {
    badge: appStoreBadge,
    alt: "Download on the App Store",
    href: "https://apps.apple.com/fi/app/lemonade-training/id6444232539",
  },
  {
    badge: googlePlayBadge,
    alt: "Get it on Google Play",
    href: "https://play.google.com/store/apps/details?id=com.MasinaComputer.TheLemonadeTraining",
  },
];

export function StoreBadges({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-3", className)}>
      {STORES.map((s) => (
        <a
          key={s.alt}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-lg transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-black"
        >
          <img src={s.badge} alt={s.alt} className="h-11 w-auto" />
        </a>
      ))}
    </div>
  );
}
